import { injectable } from "inversify";
import { IsBookableStateUseCase } from "./interface/IsBookableStateUseCase";
import { IDateInfo } from "@/domain/entities/book";
import { BookIntervalCode } from "@/types";

@injectable()
export class IsBookableState implements IsBookableStateUseCase {
  constructor() {}

  execute(
    totalAmount: number | undefined,
    bookInProgress: boolean,
    seatsSelectable: boolean,
    bookingDates: IDateInfo[],
    shouldPay: boolean,
    bookIntervalCode?: BookIntervalCode,
    realBookableDatesLength?: number
  ): boolean {
    if (totalAmount === undefined) return false;

    const hasValidPaymentAmount = shouldPay
      ? totalAmount > 0
      : totalAmount === 0;

    const isSeatSelectionValid =
      !seatsSelectable ||
      bookingDates.every((bookingDate) => bookingDate.bookableDate?.mySeatNo);

    let validBookingDates = false;
    if (bookIntervalCode) {
      validBookingDates =
        bookIntervalCode === BookIntervalCode.DAY
          ? bookingDates.length > 0
          : bookingDates.length === realBookableDatesLength;
    } else {
      validBookingDates = bookingDates.length > 0;
    }

    return (
      !bookInProgress &&
      validBookingDates &&
      hasValidPaymentAmount &&
      isSeatSelectionValid
    );
  }
}
